import React from 'react';
import { useParams } from 'react-router-dom';
import AlertsListPage from 'features/alerts/pages/AlertsListPage';
import AlertEditPage from 'features/alerts/pages/AlertEditPage';
import AlertDetailPage from 'features/alerts/pages/AlertDetailPage';

/**
 * /:team/alerts · /new · /:id (detail) · /:id/edit — same hand-rolled
 * sub-router as Agents.
 *
 * The rest of the path comes from the route's own splat, not from slicing
 * `pathname` after the team: `useParams().team` is decoded ("Trodo App") and
 * `pathname` is not ("/Trodo%20App/…"), so for any team with a space in its
 * name the two never matched and every alert URL showed the list.
 */
export default function AlertsPage() {
  const params = useParams();
  const rest = String(params['*'] || '').split('/').filter(Boolean);
  if (rest.length === 0) return <AlertsListPage />;
  if (rest[0] === 'new') return <AlertEditPage key="new" alertId="new" />;
  if (rest[1] === 'edit') return <AlertEditPage key={rest[0]} alertId={rest[0]} />;
  return <AlertDetailPage key={rest[0]} alertId={rest[0]} />;
}
